import { Icon } from '@/kit/Icon';
import { DialogActions, DialogClose, DialogContent, type DialogComponentProps } from '@/kit/dialog';

export interface ClosePopupData {
  itemName?: string;
  count?: number;
  /** What is being confirmed, in the title and the question; the default is the delete confirmation. */
  action?: 'Delete' | 'Archive' | 'Restore';
}

/** Angular `ClosePopupComponent`: the delete confirmation. Resolves true (Yes), false (No) or undefined (X / dismissed). */
export function ClosePopup({ data }: DialogComponentProps<ClosePopupData, boolean>) {
  const action = data?.action ?? 'Delete';
  return (
    <div className="mat-dialog-wrapper">
      <DialogContent>
        <div className="main-contain">
          <div className="sidenav-header">
            <div className="d-flex align-items-center justify-space-between">
              <h2>
                <span>{action === 'Delete' ? 'Confirm Delete' : `Confirm ${action}`}</span>
              </h2>
              <DialogClose>
                <Icon name="close" className="close" />
              </DialogClose>
            </div>
          </div>
        </div>
        <div>
          <p className="text-muted mb-10 fw-bold">Selected Items</p>
          <p className="font-size-18 fw-bold">
            <span className="text-muted font-size-20">Records:</span> {data?.count ?? 1}{' '}
          </p>
        </div>
        <p className="font-size-14">
          Are you sure you want to {action.toLowerCase()} <strong>{data?.itemName ?? 'Accounting Period'} </strong> ?
        </p>
      </DialogContent>
      <DialogActions>
        <div className="d-flex gap-15">
          <DialogClose as="button" result={true} type="button" className="action-button primary-button">
            Yes
          </DialogClose>
          <DialogClose as="button" result={false} type="button" className="action-button secondary-button">
            No
          </DialogClose>
        </div>
      </DialogActions>
    </div>
  );
}
